import { COLORS } from 'constants/index';

const MuiFab = {};

export default MuiFab;
